import { render, staticRenderFns } from "./ApplicationReview.vue?vue&type=template&id=77bd7a54&scoped=true"
import script from "./ApplicationReview.vue?vue&type=script&lang=js"
export * from "./ApplicationReview.vue?vue&type=script&lang=js"
import style0 from "./ApplicationReview.vue?vue&type=style&index=0&id=77bd7a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bd7a54",
  null
  
)

export default component.exports